import React from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    Legend,
    Title,
    Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Legend,
    Title,
    Tooltip
);

const BarGraph = React.forwardRef((props, ref) => {
    const options = {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.text,
            },
        },
        scales: {
            x: { stacked: props.stack },
            y: { stacked: props.stack, ticks: { beginAtZero: true } },
        },
    };

    return <Bar ref={ref} data={props.data} options={options} />;
});

export default BarGraph;
